// extracted by mini-css-extract-plugin
module.exports = {"company":"Me__company--3xzBj"};